import React from 'react';
import style from './CustomerType.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie, faHotel } from '@fortawesome/free-solid-svg-icons';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { isResourceAvailable } from '../../../../../util';
import { getSelectedResources } from '../../../../../util/resourceManager';
const { nsResources } = getSelectedResources();

const resourceCode = nsResources.APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE;

export const CustomerType = ({
  id,
  data,
  addMatchingConfig,
  referrer,
  authentication,
  value,
  closeTag,
  disabled
}) => {
  return (
    <div
      className={style.card_container}
      key={data.id}
      id={id}
      style={{
        borderColor:
          value?.matchingConfigName && data?.displayName ? '#21B4BD' : '#D0D7E3'
      }}>
      {data?.displayName && (
        <div
          className={style.card_header}
          style={{
            background: value?.matchingConfigName ? '#21B4BD' : '#F7F7F8',
            color: value?.matchingConfigName ? '#FFF' : '#748AA1'
          }}>
          <div
            className={style.card_header_icon_wrapper}
            style={{
              borderColor: value?.matchingConfigName ? '#FFF' : '#748AA1'
            }}>
            <FontAwesomeIcon
              icon={data?.code == 'INDIVIDUAL' ? faUserTie : faHotel}
              color={value?.matchingConfigName ? '#FFF' : '#748AA1'}
            />
          </div>
          <div className={style.card_header_name}>{data?.displayName}</div>
        </div>
      )}
      <div className={style.card_body}>
        {value?.matchingConfigName ? (
          <div className={style.card_mctag}>
            <p>{value?.matchingConfigName}</p>
            <button
              id={`closeTagAnchor${referrer}`}
              onClick={() => closeTag(referrer)}>
              X
            </button>
          </div>
        ) : (
          <div
            id={`addMatchingConfig${referrer}`}
            className={style.card_add_mc}
            style={{
              opacity: disabled ? '0.4' : '1',
              cursor: disabled ? 'default' : 'pointer'
            }}
            onClick={() => {
              if (
                isResourceAvailable(authentication, resourceCode) &&
                !disabled
              ) {
                addMatchingConfig(referrer);
              }
            }}>
            <div style={{ textAlign: 'center' }}>
              <FontAwesomeIcon icon={faPlus} size={'2x'} />
              <br />
              Matching Configuration
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerType;
